import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import IndexSectionHeadersDark4 from '../components/headers-dark/IndexSectionHeadersDark4';
import IndexSectionHowItWorksWhitePattern18 from '../components/how-it-works-white-pattern/IndexSectionHowItWorksWhitePattern18';
import IndexSectionTeamDarkPattern15 from '../components/team-dark-pattern/IndexSectionTeamDarkPattern15';
import IndexSectionLogoCloudsWhitePattern14 from '../components/logo-clouds-white-pattern/IndexSectionLogoCloudsWhitePattern14';
import IndexSectionHowItWorksDarkPattern10 from '../components/how-it-works-dark-pattern/IndexSectionHowItWorksDarkPattern10';
import IndexSectionNumbersWhitePattern21 from '../components/numbers-white-pattern/IndexSectionNumbersWhitePattern21';
import IndexSectionBlogDarkPattern20 from '../components/blog-dark-pattern/IndexSectionBlogDarkPattern20';
import HeroEmblaCarousel from '../components/hero/HeroEmblaCarousel';
import HeroSwiper from '../components/hero/HeroSwiper';

const meta = {
  title: 'Bagga International | Tool Bags, Pouches & Belts',
  meta: [
    { name: 'description', content: 'Bagga International offers high-quality tool bags, pouches, belts, and more for professionals and enthusiasts. Browse our categories and products.' },
    { property: 'og:title', content: 'Bagga International | Tool Bags, Pouches & Belts' },
    { property: 'og:description', content: 'Bagga International offers high-quality tool bags, pouches, belts, and more for professionals and enthusiasts.' },
    { property: 'og:image', content: '/images/site-default-og.jpg' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://baggainternational.com/' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'Bagga International | Tool Bags, Pouches & Belts' },
    { name: 'twitter:description', content: 'Bagga International offers high-quality tool bags, pouches, belts, and more for professionals and enthusiasts.' },
    { name: 'twitter:image', content: '/images/site-default-og.jpg' }
  ],
  link: [
    { rel: 'canonical', href: 'https://baggainternational.com/' }
  ],
  style: [],
  script: [],
};

export default function Index() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <HeroSwiper />
      {/* <HeroEmblaCarousel /> */}
      <IndexSectionHowItWorksWhitePattern18 />
      <IndexSectionTeamDarkPattern15 />
      <IndexSectionLogoCloudsWhitePattern14 />
      <IndexSectionHowItWorksDarkPattern10 />
      <IndexSectionNumbersWhitePattern21 />
      <IndexSectionBlogDarkPattern20 />
    </React.Fragment>
  );
}

